import { createContext, useCallback, useContext, useEffect, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const ProjectCtx = createContext(null);
const STORAGE_KEY = "rp_active_project_id";

export function ProjectProvider({ children }) {
  const { user } = useAuth();
  const [projects, setProjects] = useState([]);
  const [activeId, setActiveId] = useState(() => localStorage.getItem(STORAGE_KEY) || null);
  const [loading, setLoading] = useState(false);

  const refresh = useCallback(async () => {
    if (!user) return;
    setLoading(true);
    try {
      const { data } = await api.get("/projects");
      setProjects(data);
      // pick a default active project
      if (data.length === 0) {
        setActiveId(null);
        localStorage.removeItem(STORAGE_KEY);
      } else if (!activeId || !data.some((p) => p.id === activeId)) {
        setActiveId(data[0].id);
        localStorage.setItem(STORAGE_KEY, data[0].id);
      }
    } finally {
      setLoading(false);
    }
  }, [user, activeId]);

  useEffect(() => { refresh(); }, [user]); // eslint-disable-line react-hooks/exhaustive-deps

  const setActive = (id) => {
    setActiveId(id);
    if (id) localStorage.setItem(STORAGE_KEY, id);
    else localStorage.removeItem(STORAGE_KEY);
  };

  const active = projects.find((p) => p.id === activeId) || null;

  return (
    <ProjectCtx.Provider value={{ projects, active, activeId, setActive, refresh, loading }}>
      {children}
    </ProjectCtx.Provider>
  );
}

export const useProjects = () => useContext(ProjectCtx);
